import OperationLogComponent from './OperationLog'

function OperationLog(Vue) {

  const vueInstance = new Vue({
    render(h){
      return h(OperationLogComponent, { })
    }
  })
  const component = vueInstance.$mount()
  document.body.appendChild(component.$el)
  const operationLog = vueInstance.$children[0];

  function show(params={}){
    operationLog.show(params)
  }

  function hide(){
    operationLog.hide()
  }

  const ctx = {
    show,
    hide
  }
  return ctx
}

export default function(){
  return {
    install(Vue){
      const $operationLog = new OperationLog(Vue)
      Vue.prototype.$operationLog = $operationLog
    }
  }
}
